import classnames from 'classnames';

import styles from './purchase-preview.module.scss';

type Props = {
    shown: boolean;
};

const PurchasePreview = ({ shown }: Props) => {
    return (
        <div
            className={classnames(styles.hiddenCover, {
                [styles.shown]: shown,
            })}
        >
            <section className={styles.preview}>
                <h4>Vista previa</h4>
            </section>
        </div>
    );
};

export { PurchasePreview };
